import {
  InputFieldProps,
  FieldInputValue,
  yupSchemaToValidationFunc
} from 'components/Forms';
import { AbortCategory } from 'models/AbortCategory';
import * as Yup from 'yup';

const getReasonOptions = (
  abortCategories: AbortCategory[],
  currentCategoryId: string | null
): FieldInputValue[] => {
  if (currentCategoryId === null) {
    return [];
  }

  const currentCategory = abortCategories.find(
    category => category.id === currentCategoryId
  );

  return currentCategory
    ? currentCategory.reasons.map(reason => ({
        value: reason.id,
        label: reason.name,
        key: reason.id
      }))
    : [];
};

export const abortJobFormfields = (
  abortCategories: AbortCategory[],
  currentCategoryId: string | null,
  setCurrentCategoryId: (category: string | null) => void
): InputFieldProps[] => [
  {
    id: 'category',
    label: 'Abort category',
    name: 'category',
    qaId: 'abortJobCategory',
    inputType: 'select',
    options: abortCategories.map(option => ({
      value: option.id,
      label: option.name,
      key: option.id
    })),
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      setCurrentCategoryId(event.target.value);
    }
  },
  {
    id: 'reason',
    label: 'Abort reason',
    name: 'reason',
    qaId: 'abortJobReason',
    inputType: 'select',
    options: getReasonOptions(abortCategories, currentCategoryId)
  },
  {
    id: 'rebookable',
    label: 'Can the job be rebooked?',
    name: 'rebookable',
    qaId: 'abortJobRebookable',
    inputType: 'radio',
    options: [
      { value: 'true', label: 'Yes', key: 'true' },
      { value: 'false', label: 'No', key: 'false' }
    ]
  },
  {
    id: 'comments',
    label: 'Comments',
    name: 'comments',
    qaId: 'abortJobComments',
    inputType: 'textarea'
  }
];

const abortJobFormFieldsValidation = Yup.object().shape({
  category: Yup.string().required('Required'),
  reason: Yup.string().required('Required'),
  rebookable: Yup.string().required('Required')
});

export const abortJobFormValidation = yupSchemaToValidationFunc(
  abortJobFormFieldsValidation
);
